
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 .5C7.44.5.5 7.44.5 16c0 8.56 6.94 15.5 15.5 15.5 8.56 0 15.5-6.94 15.5-15.5C31.5 7.44 24.56.5 16 .5zm0 3c6.908 0 12.5 5.59 12.5 12.5 0 6.908-5.59 12.5-12.5 12.5-6.908 0-12.5-5.59-12.5-12.5C3.5 9.092 9.09 3.5 16 3.5zm8.763 8.142l-1.409-1.42a.75.75 0 00-1.06-.004l-8.835 8.763-3.737-3.767a.75.75 0 00-1.06-.005l-1.42 1.409a.75.75 0 00-.005 1.06l5.674 5.72a.75.75 0 001.06.005l10.788-10.7a.75.75 0 00.004-1.061z","fill":"#3E9F3C"}})])
          )
        }
      }
    